import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["input", "selector", "text"]
  static values = { "updateOrderUrl": String, themeName: String, host: Boolean, currency: String, price: String, participants: Number, isEditing: Boolean }

  choose(event) {
    if(this.hasTextTarget) this.textTarget.classList.add("hidden")

    let brandId = event.currentTarget.dataset.id
    if (typeof brandId !== 'undefined') {
      let brandName = event.currentTarget.dataset.name

      this.inputTarget.value = brandId
      if (typeof brandName !== 'undefined') this.selectorTarget.innerHTML = brandName
    } else {
      this.inputTarget.value = 0
      this.selectorTarget.innerHTML = "Default"
    }

    mixpanel.track('Selected Branding', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'isEditing': this.isEditingValue
    });
  }

  chooseAndUpdateOrder(event) {
    event.preventDefault()
    this.choose(event)

    Rails.ajax({
      url: this.updateOrderUrlValue,
      type: 'patch',
      data: new URLSearchParams({ brand_style_id: event.currentTarget.dataset.id }).toString(),
      success: (data) => {}
    })
  }

  select(e) {
    mixpanel.track('Selected Branding', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'isEditing': this.isEditingValue
    });
  }
}
